import { render } from "./FilePDF.vue?vue&type=template&id=4693f990"
import script from "./FilePDF.vue?vue&type=script&lang=js"
export * from "./FilePDF.vue?vue&type=script&lang=js"

import "./FilePDF.vue?vue&type=style&index=0&id=4693f990&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__